import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import FaqAccordion from "@/components/base/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  const preview = faqs.slice(0, 5);

  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-20" aria-label="常见问题">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-12">
        <div>
          <SectionHeading
            eyebrow="常见问题"
            title="选群前，先把这些疑问弄清楚"
            desc="我们把瓜友最常问的问题整理在这里。如果还有没覆盖到的，欢迎通过「关于我们」页面的联系方式告诉我们。"
          />
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap font-label text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <FaqAccordion items={preview} defaultOpenId={preview[0]?.id} />
      </div>
    </section>
  );
}